<template>
  <!-- 注册送金-手动领取奖励 -->
  <div>
    <PopupDialog
      ref="PopupWindowShowRef"
      :width="getIsMobile ? '100%' : '400px'"
      :show.sync="PopupWindowShow"
      className="ManualReward"
      @close="close"
    >
      <template #center>
        <div class="manual-reward-container">
          <div class="manual-header">
            <div class="txt1" :data-title="$t('Datalang.home_lucky_slot')">{{ $t('Datalang.home_lucky_slot') }}</div>
            <div class="txt2" :data-title="$t('Datalang.home_slot_machine')">{{ $t('Datalang.home_slot_machine') }}</div>
          </div>
          <div class="manual-bg">
            <img class="manual-bg-img" :src="require('@/assets/activity/register/bg.webp')" alt="" />
            <div class="manual-content">
              <div class="manual-content-title">
                <span>{{ $t('Datalang.newly_spin') }} <span class="yellow">x1</span></span>
              </div>
              <div class="manual-content-rotate" ref="rotateContainer">
                <div class="rotate-wrapper" ref="rotateWrapper">
                  <div class="manual-content-rotate-list" ref="rotateList1">
                    <div class="manual-content-rotate-item" v-for="(item, index) in rotateList" :key="'list1-'+index">
                      <img class="rotate-item-img" :src="item.img" alt="" />
                      <span class="rotate-item-text">{{ userCoinInfo.symbol }}{{ item.text }}</span>
                    </div>
                  </div>
                  <div class="manual-content-rotate-list" ref="rotateList2">
                    <div class="manual-content-rotate-item" v-for="(item, index) in rotateList" :key="'list2-'+index">
                      <img class="rotate-item-img" :src="item.img" alt="" />
                      <span class="rotate-item-text">{{ userCoinInfo.symbol }}{{ item.text }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="manual-content-button" @click="handleClick">
                <img class="button-img" :src="require('@/assets/activity/register/btn.webp')" alt="" />
                <span class="button-text">{{ $t('Datalang.home_spin') }}</span>
                <img v-show="showFinger" class="button-finger" :src="finger" alt="">
              </div>
            </div>
          </div>

          <div class="manual-footer">
            <div class="title">{{ info.title || '' }}</div>
            <div class="description" v-html="info.description || ''">
            </div>
          </div>
        </div>
      </template>
    </PopupDialog>

    <PopupDialog
      ref="rewardRef"
      width="400px"
      :show="rewardShow"
      className="rewardRef"
      @close="handleRewardClose"
    >
      <template #center>
        <div class="reward-container">
          <div class="reward-wrap">
            <div class="reward-header">
              <span class="txt1" :data-title="$t('Datalang.home_congratulation5')">{{ $t('Datalang.home_congratulation5') }}</span>
            </div>
            <img class="reward-img" :src="require('@/assets/activity/register/result.webp')" alt=""></img>
          </div>
          <div class="reward-content">
            <div class="reward-amount">{{ userCoinInfo.symbol }}{{ reward.text }}</div>
            <div class="reward-button" @click="handleRewardClose">
              <img class="button-img" :src="require('@/assets/activity/register/btn.webp')" alt="">
              <span class="button-txt">{{ $t('Datalang.home_claim') }}</span>
            </div>
          </div>
        </div>
      </template>
    </PopupDialog>
  </div>
</template>

<script>
import PopupDialog from "@/components/PopupDialog";
import {
  previewActivityReward,
} from "@/lobby_common/api/activity_gen.js";
// import { gsap } from "gsap";
import gold1 from './images/gold1.webp'
import gold2 from './images/gold2.webp'
import gold3 from './images/gold3.webp'
import gold4 from './images/gold4.webp'
import gold5 from './images/gold5.webp'
import gold6 from './images/gold6.webp'
import finger from '@/lobby_common/assets/activity/register/finger.webp'
import {
  divideAccuracy,
  loadGSAP,
} from "@/lobby_common/utils/utils";
import { getActivityDetail} from "@/lobby_common/api/activity_gen.js";
import { lock, unLock } from "@/lobby_common/utils/index.js";

let gsap = null;
export default {
  components: {
    PopupDialog,
  },
  props: [],
  data() {
    return {
      finger,
      rewardShow: false,
      PopupWindowShow: false,
      rewardObj: {},
      rotateList: [],
      totalHeight: 0,
      speed: 150, // px / second
      tween: null,
      isClick: false,
      showFinger: true,
      info: {
        title: '',
        description: '',
      }
    };
  },
  computed: {
    displayList() {
      return [...this.rotateList, ...this.rotateList];
    },
    reward() {
      return this.rotateList.find(e => e.status);
    },
    taken() {
      return this.$store.getters.taken;
    },
    getIsMobile() {
      return this.$store.getters.getIsMobile;
    },
    appSid() {
      return this.$store.getters.getPacketConfig?.appConfig?.sid;
    },
    userData() {
      return this.$store.getters.user || {};
    },
    coinCode() {
      return this.$store.state.auth.selectCoin;
    },
    userCoinCode() {
      return this.userData.coinCode || this.coinCode;
    },
    coinList() {
      return this.$store.getters.getPacketConfig?.coinList || [];
    },
    userCoinInfo() {
      return (
        this.coinList.find((item) => item.coinCode === this.userCoinCode) || {}
      );
    },
    coinInfo() {
      return this.coinList.find((i) => i.coinCode === this.userCoinCode) || {};
    }
  },
  created() {
    // this.getData();
  },
  destroyed() {
    if (this.tween) {
      this.tween.kill();
    }
    // unLock();
  },
  methods: {
    async getData() {
      // try {
      //   const cache = await getDB('getActivityDetail_ActivityTypeRegister');
      //   if (cache) {
      //     this.initData(res);
      //   }
      // } catch (error) {

      // }
      const { code, data } = await getActivityDetail({
        activityType: "ActivityTypeRegister"
      });
      if (code === 0) {
        this.initData(data);
        // setDB('getActivityDetail_ActivityTypeRegister', data);
      }
    },
    async initData(data) {
      const amount = Number(data.reward);
      this.rotateList = this.generateSlotValues(amount)
      // 活动标题和描述信息
      this.info = {
        title: data.activity.activityInfo?.activityName,
        description: data.activity.activityInfo?.content,
      }
    },
    generateSlotValues(realReward) {
      // 显示比例数组
      const ratios = [0.23, 0.30, 0.50, 0.80, 1, 1.20];
      const imgs = [gold1, gold2, gold3, gold4, gold5, gold6]

      return ratios.map((r, i) => {
        // 乘以比例四舍五入到2位小数
        const text = divideAccuracy(+((realReward * r)), this.userCoinInfo.accuracy, "point");
        return {
          status: r === 1,
          text,
          img: imgs[i]
        }
      });
    },
    handleRewardClose() {
      this.rewardShow = false;
      this.PopupWindowShow = false;
      this.rewardObj = {};
      this.$eventPost("register_success_reward");
      setTimeout(() => {
        this.$popConfig.initWinConfig(1);
      }, 300);
    },
    async show(obj) {
      await this.getData();
      if (!gsap) gsap = await loadGSAP();
      this.rewardObj = obj;
      this.PopupWindowShow = true;

      this.$nextTick(() => {
        this.waitForImagesLoaded(this.$refs.rotateList1).then(() => {
          this.safeUpdateHeight();
          this.startScroll();
          // lock();
        });
      });
    },
    safeUpdateHeight() {
      let retries = 0;
      const check = () => {
        const h = this.$refs.rotateList1?.offsetHeight || 0;
        if (h > 50 || retries > 5) {
          this.totalHeight = h;
          console.log('✅ final height:', h);
        } else {
          retries++;
          setTimeout(check, 200);
        }
      };
      check();
    },
    waitForImagesLoaded(container) {
      return new Promise((resolve) => {
        const imgs = container?.querySelectorAll('img') || [];
        let loadedCount = 0;
        if (imgs.length === 0) return resolve();

        imgs.forEach((img) => {
          if (img.complete) {
            loadedCount++;
            if (loadedCount === imgs.length) resolve();
          } else {
            img.onload = img.onerror = () => {
              loadedCount++;
              if (loadedCount === imgs.length) resolve();
            };
          }
        });
      });
    },
    close() {
      // unLock();
      if (this.tween) {
        this.tween.kill();
      }
      this.PopupWindowShow = false;
    },
    async handleClick() {
      if (this.isClick) {
        // 防止重复点击
        return;
      }
      this.isClick = true;
      this.showFinger = false;
      this.$eventPost("register_success_spin");

      // 领取
      const res = await previewActivityReward({
        activityType: "ActivityTypeRegister",
      });
      if (res.code !== 0) {
        return;
      }

      if (!this.tween) return;

      // 获取目标位置（第5个位置，status为1的奖品）
      const targetIndex = this.rotateList.findIndex(item => item.status);
      const targetY = (this.totalHeight / this.rotateList.length) * targetIndex;

      // 创建动画序列
      const timeline = gsap.timeline({
        onComplete: () => {
          this.isClick = false;
          // 重新开始慢速滚动
          // this.startScroll();
          this.tween.kill();
          this.rewardShow = true;
        }
      });

      // 1. 快速加速阶段（将当前滚动速度提升到很快）
      timeline.to(this.tween, {
        timeScale: 8, // 8倍速
        duration: 1.2,
        ease: "power1.in"
      });

      // 2. 匀速阶段（保持较快速度）
      timeline.to(this.tween, {
        timeScale: 6, // 6倍速
        duration: 1.5,
        ease: "none"
      });

      // 3. 减速并停在目标位置
      timeline.to(this.tween, {
        timeScale: 0.1, // 明显降速
        duration: 1.3,
        ease: "power2.in",
        onComplete: () => {
          // 停止滚动
          this.tween.kill();

          // 确保停在正确位置
          const currentY = gsap.getProperty(this.$refs.rotateWrapper, "y") || 0;
          const adjustY = currentY % this.totalHeight;
          gsap.to(this.$refs.rotateWrapper, {
            y: adjustY + targetY,
            duration: 0.5,
            ease: "power2.out"
          });
        }
      });
    },
    startScroll() {
      const wrapper = this.$refs.rotateWrapper;
      if (!wrapper) return;

      // 计算一次完整滚动的距离
      // const totalHeight = this.itemHeight * this.rotateList.length;
      const totalHeight = this.totalHeight;

      // 设置第二个列表的初始位置
      gsap.set(this.$refs.rotateList2, { y: -totalHeight });

      // 创建无限滚动动画
      this.tween = gsap.to(wrapper, {
        y: totalHeight,
        duration: totalHeight / this.speed,
        ease: "none",
        repeat: -1,
        onRepeat: () => {
          gsap.set(wrapper, { y: 0 });
        }
      });
    },
  },
};
</script>
<style lang="scss">
.ManualReward {
  &#dialog{
    .el-dialog{
      @media (max-width: 768px) {
        width: 100% !important;
      }
    }
  }
  .el-dialog {
    background: none !important;
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__header {
      display: none !important;
    }
  }
}
.rewardRef{
  .el-dialog {
    overflow: unset !important;
    background: none !important;
    .el-dialog__body {
      padding: 0;
    }
    .el-dialog__header {
      display: none !important;
    }
  }
}
</style>
<style lang="scss" scoped>
@mixin font-gold{
  -webkit-text-stroke: 2px var(--stroke-color-register-1);
  filter: drop-shadow(0 3px 0 var(--stroke-color-register-1));
  font-weight: bold;
  font-style: italic;
  &::before{
    content: attr(data-title);
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    background-image: var(--background-register-1);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 0;
    pointer-events: none;
  }
}
@mixin font-gold2{
  -webkit-text-stroke: 2px var(--stroke-color-register-2);
  filter: drop-shadow(0 3px 0 var(--stroke-color-register-2));
  font-weight: bold;
  font-style: italic;
  &::before{
    content: attr(data-title);
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    background-image: var(--background-register-2);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 0;
    pointer-events: none;
  }
}
@mixin font-gold3{
  -webkit-text-stroke: 2px var(--stroke-color-register-2);
  filter: drop-shadow(0 3px 0 var(--stroke-color-register-2));
  font-weight: bold;
  font-style: italic;
  &::before{
    content: attr(data-title);
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    background-image: var(--background-register-2);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 0;
    pointer-events: none;
  }
}
.manual-reward-container {
  position: relative;
  .manual-header{
    font-size: 30px;
    text-align: center;
    .txt1{
      position: relative;
      @include font-gold2;
    }
    .txt2{
      position: relative;
      @include font-gold;
    }
  }
  .manual-bg {
    padding: 0 20px 20px 20px;
    position: relative;
    .manual-bg-img {
      width: 100%;
      height: auto;
    }
  }
  .manual-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    &-title {
      position: absolute;
      top: 18.6%;
      left: 50%;
      transform: translateX(-50%);
      width: 30%;
      color: #fff;
      font-size: 16px;
      text-align: center;
      @include textOverflow(1);
      .yellow {
        color: #f8ef06;
      }
    }
    &-rotate {
      position: absolute;
      top: 26%;
      left: 50%;
      width: 27%;
      height: 46%;
      transform: translateX(-50%);
      overflow: hidden;
      .rotate-wrapper {
        position: relative;
        width: 100%;
      }
      &-list {
        position: absolute;
        width: 100%;
        left: 0;
      }
      &-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;
        overflow: hidden;
        .rotate-item-img {
          width: 50px;
          height: auto;
        }
        .rotate-item-text {
          margin-top: -6px;
          font-size: 20px;
          color: #034e03;
          font-weight: bold;
          text-align: center;
        }
      }
    }
    &-button {
      position: absolute;
      bottom: 8%;
      left: 50%;
      transform: translateX(-50%);
      width: 43%;
      animation: breath 1s ease-in-out infinite;
      cursor: pointer;
      .button-img {
        width: 100%;
        height: auto;
      }
      .button-text {
        padding-bottom: 4px;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 90%;
        transform: translate(-50%, -50%);
        font-size: 24px;
        color: #fff;
        text-align: center;
        @include textOverflow(1);
      }
      .button-finger{
        position: absolute;
        width: 50px;
        right: 0;
        top: 50%;
        animation: fingerAnimation 1s linear infinite;
      }
    }
  }
  .manual-footer{
    padding: 20px;
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(0,0,0,.6);
    .title{
      text-align: center;
      font-size: 18px;
      color: #fbce06;
    }
    .description{
      color: #fff;
    }
  }
}

@keyframes breath {
  0% {
    transform: translateX(-50%) scale(1);
  }
  50% {
    transform: translateX(-50%) scale(1.06);
  }
  100% {
    transform: translateX(-50%) scale(1);
  }
}

@keyframes fingerAnimation {
  0% {
    transform: translateY(10px);
  }

  50% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(10px);
  }
}

.reward-container{
  position: relative;
  transform: translateY(5vh);
  .reward-wrap{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .reward-header{
      position: absolute;
      top: -10px;
      left: 0;
      width: 100%;
      text-align: center;
      .txt1{
        font-size: 32px;
        @include font-gold3;
      }
    }
    .reward-img{
      width: 260px;
      height: auto;
    }
  }
  .reward-content{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    .reward-amount{
      position: absolute;
      top: 15%;
      left: 0;
      width: 100%;
      text-align: center;
      font-family: AvertaStd-Semibold;
      font-size: 26px;
      font-weight: bold;
      color: #fcf648;
    }
    .reward-button{
      position: absolute;
      bottom: -60px;
      left: 50%;
      transform: translateX(-50%);
      width: 170px;
      cursor: pointer;
      .button-img{
        width: 100%;
        height: auto;
      }
      .button-txt{
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        text-align: center;
        font-size: 20px;
        box-sizing: border-box;
        padding: 0 10px 6px 10px;
        color: #fff;
        transform: translateX(-50%) translateY(-50%);
        @include textOverflow(1);
      }
    }
  }
}
</style>
